<template>
  <div class="oneClass" ref="oneClass">
    <div class="wrap-data" v-for="(item, index) in dataList" :key="index">
      <h1 @click="wdDetails(item)">{{ item.variation }}</h1>
      <!-- <div class="Circle">
        <p>丰度：</p>
        <div>
          <van-circle
            v-model="currentRate"
            color="#4B84FF"
            layer-color="#ffffff"
            :rate="20"
            :stroke-width="100"
            text="12.4%"
          /> 
        </div>
      </div> -->
      <div class="Target">
        <h2>靶向药物:</h2>
        <div class="Target-list">
          <p v-for="(i, index) in item.sensitivityDrugs" :key="index">
            {{ i }}
          </p>
        </div>
        <div class="icon-box" v-if="$route.query.userAgent != 'wxWeb'" @click="handlePill(item)">
          <!-- <i class="iconfont icon-yongyao"></i> -->
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-yongyao"></use>
          </svg>
          <!-- <div class="l"></div>
          <div class="r"></div> -->
        </div>
      </div>
    </div>

    <!-- <div class="btn">
      <div class="ts-info" @click="isNotes">
        <span>!</span>
        注释
      </div>
      <button @click="handleDetails('variationDetails')">
        检测结果详情<i class="iconfont icon-right_medium"></i>
      </button>
    </div> -->
  </div>
</template>
<script>
import { Toast } from "vant";
import isiOS from "@/utils/iosAn";

export default {
  props: {
    dataList: {
      type: Array,
    },
  },
  data() {
    return {
      notesText: {
        h1: "",
        p: "",
      },
      isShow: false,
      wrapData: [],
      currentRate: 0,
      TargetList: [],
      ocdata: "",
      type: {
        name: "variationDetails",
        id: 12,
      },
    };
  },
  created() {
    window.NativeCallJS = (res) => {
      this.native(res);
    };
  },
  mounted() {},
  methods: {
    handlePill(item) {
      console.log(item.sensitivityDrugs);
      if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage({
          name: "pill",
          gene: item.variation,
          arrList: item.sensitivityDrugs,
        });
      } else {
        window.android.JSCallNative(
          JSON.stringify({
            name: "pill",
            gene: item.variation,
            type: "",
            arrList: item.sensitivityDrugs,
          })
        );
      }
    },
    appSource() {
      if (isiOS) {
        console.log("ios");
        return "ios";
      } else {
        console.log("andriod");
        return "andriod";
      }
    },
    native(res) {
      Toast(res);
    },
    // 点击跳转详情
    handleDetails(name) {
      if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage({ name: name });
      } else {
        window.android.JSCallNative(JSON.stringify({ name: name, type: "" }));
      }
      // this.$router.push({
      //   name: "variationDetails",
      //   query: {
      //     sessionId: this.$route.query.sessionId,
      //   },
      // });

      // window.webkit.messageHandlers.JSCallNative.postMessage(this.type);
    },
    wdDetails(item) {
      let param = {
        name: "wdJiedu",
        type: "1",
        wdName: item.variation,
        gene: "",
        proteinChange: item.variation,
        tabIndex: "2",
        variantType: item.variantType,
        webId: "BGXQ-825",
      };
      let par = encodeURI(item.variation).replace(/\+/g, "%2B");
      if (this.$route.query.userAgent == "wxWeb") {
        wx.miniProgram.navigateTo({ 
          url: '/packageWebView/pages/site-jiedu/site-jiedu?site='+par
        });
      } else if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage(param);
      } else {
        window.android.JSCallNative(JSON.stringify(param));
      }
    },
    isNotes() {
      this.notesText = {
        h1: "遗传易感相关变异注释1122",
        p: "克唑替尼*+雷莫芦单抗/贝伐",
      };
      this.$refs.child.ishow();
    },
  },
};
</script>
<style lang="less" scoped>
.oneClass {
  .btn {
    text-align: center;
    display: flex;
    justify-content: center;
    margin-top: 10px;
    button {
      width: 136px;
      height: 32px;
      background: linear-gradient(270deg, #60adff 0%, #4b84ff 100%);
      box-shadow: 0px 4px 10px 0px rgba(75, 132, 255, 0.2);
      border-radius: 16px;
      outline: none;
      border: 0;
      font-size: 12px;
      font-family: @family;
      font-weight: 400;
      color: #ffffff;
      margin-left: 12px;
      i {
        font-size: 10px;
      }
    }
  }

  .ts-info {
    width: 80px;
    height: 32px;
    background: #ffffff;
    box-shadow: 0px 4px 10px 0px rgba(52, 68, 132, 0.08);
    border-radius: 16px;
    text-align: center;
    line-height: 32px;
    span {
      display: inline-block;
      width: 14px;
      min-width: 14px;
      height: 14px;
      border-radius: 14px;
      background: #ffdb4d;
      text-align: center;
      line-height: 14px;
      font-weight: 500;
      font-size: 10px;
    }

    p {
      font-size: 12px;
      font-family: @family;
      font-weight: 400;
      color: #9095a7;
      line-height: 17px;
    }
  }

  .wrap-data {
    padding: 0 24px;

    .Target {
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #e3e5e8;
      padding-bottom: 20px;
      margin-bottom: 20px;
      .icon-box {
        width: 32px;
        min-width: 32px;
        height: 32px;
        background: #ffffff;
        border-radius: 6px;
        border: 1px solid #f3f5f8;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 6px;
        .icon {
          width: 16px;
          height: 16px;
          fill: currentColor;
          overflow: hidden;
        }
      }

      .Target-list {
        width: 100%;
        min-width: 178px;
        text-align: left;
        padding-right: 20px;
        p {
          font-size: 13px;
          font-family: @family;
          font-weight: 400;
          color: #2f354d;
          line-height: 28px;
        }
      }

      h2 {
        min-width: 60px;
        font-size: 13px;
        font-family: @family;
        font-weight: 400;
        color: #a4a9bf;
        line-height: 28px;
      }
    }

    .Circle {
      margin-top: 20px;
      margin-bottom: 16px;
      display: flex;

      /deep/.van-circle {
        width: 52px;
        height: 52px;

        .van-circle__text {
          font-size: 12px;
          font-weight: normal;
          color: #2f354d;
        }
      }

      p {
        font-size: 13px;
        font-family: @family;
        font-weight: 400;
        color: #a4a9bf;
        line-height: 28px;
        margin-right: 22px;
      }
    }

    h1 {
      font-size: 15PX;
      font-weight: 500;
      color: #4b84ff;
      line-height: 22px;
      position: relative;
      padding-left: 12px;
      margin-bottom: 20px;
      &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 10px;
        margin-top: -7px;
        width: 3px;
        height: 14px;
        background: #4b84ff;
        border-radius: 2px;
      }
    }
  }
}
</style>
